// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3bd794d8","453":"9053622d","455":"89ae643a"}[chunkId] + ".chunk.js";
};